export default __webpack_public_path__ + "static/media/signed-document.003fef71.svg";